module.exports = __webpack_public_path__ + "img/menu4-1.485bb5ef.svg";